function cleanBaseUrl(value: string): string {
  return value.replace(/\/+$/u, '')
}

const variables = import.meta.env

export const platformEnv = {
  ssoApiUrl: cleanBaseUrl(variables.VITE_SSO_API_BASE_URL || 'https://api-sso.hocnhe.com'),
  ssoFrontendUrl: cleanBaseUrl(variables.VITE_SSO_FRONTEND_URL || 'https://sso.hocnhe.com'),
  ssoClientId: (variables.VITE_SSO_CLIENT_ID || 'shop').trim(),
  ecomApiUrl: cleanBaseUrl(variables.VITE_ECOM_API_BASE_URL || 'https://ecom-api.hocnhe.com'),
  aiGatewayUrl: cleanBaseUrl(variables.VITE_AI_GATEWAY_BASE_URL || 'https://ai.hocnhe.com'),
} as const
